"use client";
import LocaleSwitcher from "@/i18n/LanguageSwitcher";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
import { useReservationContext } from "ui/context";

const LoginPageContent = dynamic(
  () => import("ui/pages").then((module) => module.LoginPageContent),
  { ssr: false }
);

export default function LoginPage({
  searchParams: { callbackUrl, reservationId, error },
}: {
  searchParams: { callbackUrl: string; reservationId: string; error: string };
}) {
  const t = useTranslations();
  const { setReservationId } = useReservationContext();

  return (
    <LoginPageContent
      callbackUrl={callbackUrl}
      error={error}
      t={t}
      localeSwitcher={<LocaleSwitcher />}
      changeSelectedReservation={() =>
        reservationId ? setReservationId(reservationId) : null
      }
    />
  );
}
